import { apiSlice } from "../../app/api/apiSlice";

// All endpoints are mocked for the mockup phase.
// Replace query functions with real API calls during backend integration.

export const currentLoanApiSlice = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		uploadLoanXml: builder.mutation({
			query: (formData) => ({
				url: "/api/v1/loans/upload-xml",
				method: "POST",
				body: formData,
			}),
		}),
		runCreditReissue: builder.mutation({
			query: (body) => ({
				url: "/api/v1/loans/credit-reissue",
				method: "POST",
				body,
			}),
		}),
		fetchEligiblePrograms: builder.mutation({
			query: (body) => ({
				url: "/api/v1/loans/eligible-programs",
				method: "POST",
				body,
			}),
		}),
		// Starts Sapiens Decision Assist (sets CX.AUS.* fields, fires the decision event).
		// Resolves { status: "in_progress" | "not_configured", requestedAt }.
		runAura: builder.mutation({
			query: (body) => ({
				url: "/api/v1/loans/run-aura/",
				method: "POST",
				body,
			}),
		}),
		// Polls CX.AUS.RESULT; once no longer "In Progress" also returns the findings
		// PDF attachment id from the Encompass eFolder.
		getAuraStatus: builder.query({
			query: (loanGuid) => `/api/v1/loans/${loanGuid}/aura-status/`,
			keepUnusedDataFor: 0,
		}),
		// AURA Run Process step 8: CX.WRE.LASTRUN (Workflow Rules engine last run), read
		// through the Encompass field reader; the engine is done once two reads match.
		getRulesEngineStatus: builder.query({
			query: (loanGuid) => `/api/v1/loans/${loanGuid}/rules-engine-status/`,
			keepUnusedDataFor: 0,
		}),
		// LC-696: AURA eligibility messages + Minimum Submission / Preliminary Credit
		// documentation conditions, read live from Encompass.
		getAuraConditions: builder.query({
			query: (loanGuid) => `/api/v1/loans/${loanGuid}/aura-conditions/`,
			keepUnusedDataFor: 0,
		}),
		submitExceptionRequest: builder.mutation({
			query: (body) => ({
				url: "/api/v1/loans/exception-request/",
				method: "POST",
				body,
			}),
		}),
		submitLoan: builder.mutation({
			query: (loanGuid) => ({
				url: `/api/v1/loans/${loanGuid}/submit/`,
				method: "POST",
			}),
		}),
		saveCurrentLoanProgress: builder.mutation({
			query: ({ loanGuid, ...body }) => ({
				url: `/api/v1/loans/${loanGuid}/progress/`,
				method: "PATCH",
				body,
			}),
		}),
		getCurrentLoanProgress: builder.query({
			query: (loanGuid) => `/api/v1/loans/${loanGuid}/progress/`,
		}),
	}),
});

export const {
	useUploadLoanXmlMutation,
	useRunCreditReissueMutation,
	useFetchEligibleProgramsMutation,
	useRunAuraMutation,
	useLazyGetAuraStatusQuery,
	useLazyGetAuraConditionsQuery,
	useLazyGetRulesEngineStatusQuery,
	useSubmitExceptionRequestMutation,
	useSubmitLoanMutation,
	useSaveCurrentLoanProgressMutation,
	useLazyGetCurrentLoanProgressQuery,
} = currentLoanApiSlice;
